import * as types from './types';
import {
  SchoolAdminToolBookStatementStudentListModel,//学生列表
  SchoolAdminToolBookStatementStudentCourseListModel,//学生导入列表
} from 'src/model/index';
import {
  extend,
  findIndex
} from 'lodash';

export default{
  // 学生列表
  actionGetToolBookStatementStudentList({commit, state}, query){
    if (state.toolBookStatementStudentList.state === 'loading') {
      return Promise.reject();
    }
    commit(types.ADMIN_TOOL_BOOK_STATEMENT_STUDENT_LIST, {
      state: 'loading'
    });
    return SchoolAdminToolBookStatementStudentListModel.getInstance().execute(query).then((response) => {
      commit(types.ADMIN_TOOL_BOOK_STATEMENT_STUDENT_LIST, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ADMIN_TOOL_BOOK_STATEMENT_STUDENT_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
  // 学生导入列表
  actionGetToolBookStatementStudentCourseList({commit, state}, query){
    if (state.toolBookStatementStudentCourseList.state === 'loading') {
      return Promise.reject();
    }
    commit(types.ADMIN_TOOL_BOOK_STATEMENT_STUDENT_COURSE_LIST, {
      state: 'loading'
    });
    return SchoolAdminToolBookStatementStudentCourseListModel.getInstance().execute(query).then((response) => {
      commit(types.ADMIN_TOOL_BOOK_STATEMENT_STUDENT_COURSE_LIST, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ADMIN_TOOL_BOOK_STATEMENT_STUDENT_COURSE_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
}






// WEBPACK FOOTER //
// ./src/store/Admin/modules/semesterStudentMoney/actions.js